var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#star_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#star_svg__b)",
  d: "M6.833 0 8.69 3.394l3.394 1.856L8.69 7.106 6.833 10.5 4.977 7.106 1.583 5.25l3.394-1.856z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#star_svg__c)",
  d: "m14.333 7.5 1.326 2.424 2.424 1.326-2.424 1.326L14.333 15l-1.326-2.424-2.424-1.326 2.424-1.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#star_svg__d)",
  d: "m6.833 13.5.796 1.454 1.454.796-1.454.796L6.833 18l-.795-1.454-1.455-.796 1.455-.796z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "star_svg__b",
  x1: 2.061,
  x2: 9.073,
  y1: 3.063,
  y2: 10.235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "star_svg__c",
  x1: 10.924,
  x2: 15.933,
  y1: 9.688,
  y2: 14.81,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "star_svg__d",
  x1: 4.788,
  x2: 7.793,
  y1: 14.813,
  y2: 17.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "star_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.833 0h18v18h-18z"
})))));
export default SvgStar;